var React = require('react');
var createReactClass = require('create-react-class');
var assign = require('object-assign');
var FuzzyReaction = require('../../bootstrap').FuzzyReaction;
var Table = FuzzyReaction.Components.Visualization.Tables.Table;
var Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
var PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
var Filter = FuzzyReaction.Components.Visualization.Filter;
var PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
var Modal = FuzzyReaction.Components.Global.Modal;
var Column = FuzzyReaction.Components.PageStructure.Column;
var Row = FuzzyReaction.Components.PageStructure.Row;
var AddAction = FuzzyReaction.Components.ResourceBinding.CreateResourceAction;
var ResourceActions = FuzzyReaction.Actions.ResourceActions;
var FormStore = FuzzyReaction.Stores.FormStore;
var SubscriptionTypesStore = require('../../stores/SubscriptionTypesStore');
var EditSubscription = require('./components/EditSubscription');

/**
 * The Users list page view component
 *
 * @type {*|Function}
 */
var Subscriptions = createReactClass({
    displayName: 'Subscriptions',

    getInitialState: function () {
		return {
			currentPageData:     [],
			openDeactivateModal: false,
			openEditModal:       false,
			workingResource:     {}
		};
	},

    /**
	 * Set up resource actions
	 */
    resourceActions: new ResourceActions('products'),

    /**
	 * Resource action options
	 */
    getOptions: {
		modifiers: {
			other: {
				show_deleted: true
			}
		},
		dataNode:  'data'
	},

    sendOptions: {
		modifiers: {
			other: {
				show_deleted: true
			}
		},
		dataNode:  'data',
		refresh:   'list'
	},

    requestTableData: function (modifiers) {
		// Merge modifiers with already present ones
		this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

		this.resourceActions.listResource(this.getOptions);
	},

    /**
	 * Register event listeners and fire request for data
	 */
    componentDidMount: function () {
		this.requestTableData();

		this.changeListener = this._onChange;
		SubscriptionTypesStore.addChangeListener(this.changeListener);
	},

    /**
	 * Deregister an event listener
	 */
    componentWillUnmount: function () {
		SubscriptionTypesStore.removeChangeListener(this.changeListener);
	},

    /**
	 * Handle changes in data and request paginated data
	 *
	 * @private
	 */
    _onChange: function () {
		this.setState({
			subscriptionTypes: SubscriptionTypesStore.getResourceListData()
		});
	},

    /**
	 * @todo the modals can be their own components
	 * @param action
	 * @param resource
	 */
    handleAction: function (action, resource) {
		switch (action) {
			case 'deactivate':
				this.setState({
					openDeactivateModal: true,
					workingResource:     resource,
					resourceOperation:   action
				});
				break;
			case 'create':
				this.setState({
					openEditModal:     true,
					workingResource:   {},
					resourceOperation: action
				});
				break;
			case 'saveRow':
				this.setState({
					workingResource:   resource,
					resourceOperation: action
				}, this.updateSubscription);
				break;
			case 'cancelEditRow':
				this.requestTableData();
				break;
		}
	},

    /**
	 * Fire the deactivate subscription action
	 */
    deactivateSubscription: function () {
		this.resourceActions.deactivateResource(this.state.workingResource, this.sendOptions);
	},

    /**
	 * Fire the update subscription action
	 * @param resource
	 */
    updateSubscription: function () {
		if (this.state.resourceOperation === 'create') {
			this.resourceActions.createResource(this.state.workingResource, this.sendOptions);
		} else {
			this.resourceActions.updateResource(this.state.workingResource, this.sendOptions);
		}
	},

    /**
	 * Edit subscription form
	 */
    formKey: 'editSubscription',

    /**
	 * Hanlde changes to editSubscription form
	 */
    bindResource: function () {
		this.setState({
			workingResource: FormStore.getResource(this.formKey),
			formIsValid:     FormStore.isFormValid(this.formKey)
		});
	},

    /**
	 * Close all modals and reset the working resource
	 */
    closeModal: function () {
		this.setState({
			openDeactivateModal: false,
			openEditModal:       false,
			workingResource:     {}
		});
	},

    /**
	 * Map product properties to table columns
	 */
    tableKeys: {
		"Subscription Label": 'label',
		"Price":              'price',
		"SKU":                'sku'
	},

    render: function () {
		var options = {
			actionableRows:  true,
			actions:         ['deactivate:danger'],
			actionsCallback: this.handleAction,
			editableRows:    true,
			tooltips:        {
				'SKU':      ['Actual SKUs of subscriptions is set in ', <a href="">iTunes Connect</a>, '.'],
				'Duration': 'Duration of something important'
			}
		};

		return (
			<div id="page-wrapper">
				<div id="page-content">
					<div id="content"></div>
					<Row classes="align-items-center">
						<Column grid="lg" size="6">
							<h1 className="page-header">Subscriptions</h1>
						</Column>
					</Row>

					<Column grid="lg" size="12">
						<Table data = {this.state.subscriptionTypes}
							dataKeys={this.tableKeys}
							title="Subscription Types" options={options} />
					</Column>
				</div>

				<Modal openWhen={this.state.openDeactivateModal}
					title="Deactivate?" closeText="Close"
					saveText="Deactivate" afterClose={this.closeModal}
					beforeSave={this.deactivateSubscription}
					afterSave={this.closeModal} >
					<p>You’re about to deactivate a group
						of instructors. In order to reactivate
						their accounts, you will have to do
						so individually in the actions column.</p>
					<p>Continue with deactivating their accounts&#63;</p>
				</Modal>

				<AddAction createResource={this.handleAction}>
					{this.state.openEditModal && (
						<Modal openWhen={this.state.openEditModal} options={{width: '30%'}}
							title="Create Subscription"
							closeText="Close" saveText="Save Changes"
							afterClose={this.closeModal}
							beforeSave={this.updateSubscription}
							afterSave={this.closeModal} >
							<EditSubscription resource={this.state.workingResource} bindResource={this.bindResource} />
						</Modal>
					)}
				</AddAction>
			</div>
		)
	},
});

module.exports = Subscriptions;
